<template>
  <div class="flex flex-col gap-16">
    <BittsRadioGroupCards
      form-label="Reason"
      orientation="vertical"
      :options="DECLINE_REASONS"
      :initial-value="reason"
      data-testid="decline-reason-options"
      @change="handleReasonChange"
    >
      <template #label="{ option }">
        <span>{{ (option as DeclineReasonOption).label }}</span>
        <span
          v-if="
            (option as DeclineReasonOption).value ===
            DECLINE_REASON_PREFER_NOT_TO_SAY
          "
          class="decline-reason-fields__hint"
        >
          No reason will be sent to the recipient
        </span>
      </template>
    </BittsRadioGroupCards>
    <BittsTextArea
      v-model="note"
      :form-label="{ title: 'Additional notes', secondaryText: 'Optional' }"
      placeholder="Add a note to share with your partner"
      data-testid="decline-note-input"
      :disabled="isPreferNotToSay"
      :status="isNoteTooLong ? 'danger' : 'default'"
      :danger-text="`Your note may not exceed ${MAX_DECLINE_NOTE_LENGTH} characters`"
    />
  </div>
</template>

<script setup lang="ts">
import { BittsRadioGroupCards, BittsTextArea } from '@crossbeam/bitts';

import { computed } from 'vue';

import {
  DECLINE_REASONS,
  DECLINE_REASON_PREFER_NOT_TO_SAY,
  type DeclineReasonOption,
  type DeclineReasonType,
  MAX_DECLINE_NOTE_LENGTH,
} from '@/constants/decline_reasons';

const reason = defineModel<DeclineReasonType | undefined>('reason');
const note = defineModel<string>('note', { default: '' });

const isPreferNotToSay = computed(
  () => reason.value === DECLINE_REASON_PREFER_NOT_TO_SAY,
);
const isNoteTooLong = computed(
  () => note.value.length > MAX_DECLINE_NOTE_LENGTH,
);

function handleReasonChange(value: DeclineReasonType) {
  reason.value = value;
  if (value === DECLINE_REASON_PREFER_NOT_TO_SAY) note.value = '';
}
</script>

<style lang="pcss" scoped>
@reference "../../css/theme.css";

.decline-reason-fields__hint {
  @apply text-neutral-text text-sm italic ml-4;
}
</style>
